import React from "react";

const NavSpacer = () => {
  return <div className='navBarSpacer' style={{ height: "2.8rem" }}></div>;
};

export default NavSpacer;
